function createProps(props, className) {
  const newProps = {};
  const ariaMatch = /\baria-"*/;
  const dataMatch = /\bdata-"*/;
  Object.keys(props) // Most of the props are React-only and shouldn't go on the DOM element
  // accept `children`, `style`, and any HTML property
  .filter( // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  key => key === 'children' || key === 'style' || key.match(ariaMatch) || key.match(dataMatch)).forEach(key => newProps[key] = props[key]);
  return { ...newProps,
    className
  };
}

export { createProps };
